import React from 'react';
import Button from 'mf-react-ui/Button';
import Modal from 'mf-react-ui/Modal';
import { H2, H3, P } from 'mf-react-ui/Typography';
import ContentAuth from '../../../../components/ContentAuth/ContentAuth';
import { Props, HandleGiveButtonClickParams } from './types';
import { Modals } from '../../types';
import auth from '../../../auth/utils/mym';
import ThrobberForPage from '../../../../components/ThrobberForPage/ThrobberForPage';
import { EventCat, EventGTM, EventId, EventName, trackEventBound } from '../../../../utils/ga';
import '../../style.scss';
import './SubscriptionOptionsModal.scss';

const SubscriptionOptionsModal: React.FC<Props> = (props) => {
  const {
    isOpen,
    partner,
    image,
    title,
    description,
    items,
    msisdn,
    onClose,
    showModal,
    hideModal,
  } = props;

  const handleCloseButtonClick = () => {
    onClose();
    hideModal();
  };
  const handleGiveButtonClick = ({
    subscriptionOptionTitle,
    price,
    serviceName,
  }: HandleGiveButtonClickParams): void => {
    if (!msisdn) {
      auth.authOTP();

      return;
    }

    showModal({
      modalType: Modals.FormSendGift,
      modalProps: {
        partner,
        serviceName,
        price,
        onClose: () => {
          onClose();
          trackEventBound(
            EventGTM.MakeActions,
            EventId.ClickCloseButtonInFormSendGiftModal,
            EventCat.Gift,
            EventName.ClosePopup,
            'Закрыть'
          );
        },
      },
    });
    trackEventBound(
      EventGTM.MakeConversions,
      EventId.ClickSubscriptionOptionButton,
      EventCat.Gift,
      EventName.Submit,
      `${partner} / ${subscriptionOptionTitle} / ${price}р / Подарить`
    );
  };

  return (
    <Modal
      className="modal_subscriptions-options"
      titleText="Подарок"
      initialFocus=".modal__close"
      isOpen={isOpen}
      size="l"
      onCloseButtonClick={handleCloseButtonClick}
    >
      <div className="dialog-subscription-options">
        <div className="dialog-subscription-options__image-wrapper">
          <div className="dialog-subscription-options__image-wrapper-inner">
            <img
              src={image.split(',')[0]}
              srcSet={image.split(',').slice(1).join(',')}
              className="dialog-subscription-options__image"
              alt=""
            />
          </div>
        </div>
        <div className="dialog-subscription-options__intro">
          <H2 className="dialog-subscription-options__title" align="center">
            {title}
          </H2>
          <div
            className="dialog-subscription-options__description"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        <ul className="dialog-subscription-options__list">
          {items.map((item) => {
            const {
              id,
              title: subscriptionOptionTitle,
              description: subscriptionOptionDescription,
              price,
              priceOld,
              serviceName,
            } = item;
            const button = (
              <Button
                className="dialog-subscription-option__button"
                onClick={() =>
                  handleGiveButtonClick({ subscriptionOptionTitle, price, serviceName })
                }
              >
                Подарить
              </Button>
            );

            return (
              <li key={id} className="dialog-subscription-options__item">
                <div className="dialog-subscription-option">
                  <H3 className="dialog-subscription-option__title">{subscriptionOptionTitle}</H3>
                  <P className="dialog-subscription-option__description">
                    {subscriptionOptionDescription}
                  </P>
                  <P className="dialog-subscription-option__price">
                    <span className="dialog-subscription-option__price-old">{priceOld} ₽</span>
                    <span className="dialog-subscription-option__price-current">{price} ₽</span>
                  </P>
                  <ContentAuth
                    contentWithAuth={button}
                    contentWithNoAuth={button}
                    contentWithPending={<ThrobberForPage />}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </Modal>
  );
};

export default SubscriptionOptionsModal;
